import { render, staticRenderFns } from "./SQuesNineteen.vue?vue&type=template&id=62984a3c&scoped=true&"
import script from "./SQuesNineteen.vue?vue&type=script&lang=js&"
export * from "./SQuesNineteen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62984a3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
